// extracted by mini-css-extract-plugin
module.exports = {"presentersHolder":"PresentersWebcam_presentersHolder__WT7XK","presentersHolderTopBorder":"PresentersWebcam_presentersHolderTopBorder__3YcOM"};